import { Component, Input } from '@angular/core';
import { IconV3Component } from '@gea/digital-ui-lib';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'document-file-icon-renderer',
  template: `
    <span>
      <geaui-icon-v3
        file="{{ getFileType(rowData.FileType) }}"
        [isFileIcon]="true"
        [fileSize]="24"
        pTooltip="{{ rowData.FileType }}"
      ></geaui-icon-v3>
    </span>
  `,
  standalone: true,
  imports: [IconV3Component, TooltipModule],
})
export class RenderFileIcon {
  @Input() rowData: any;

  getFileType(fileType: string) {
    switch (fileType) {
      case 'Document':
        return 'unknown';
      case 'DWG':
        return 'dwg';
      case 'JPEG':
        return 'jpeg';
      case 'Layout':
        return 'unknown';
      case 'PDF':
        return 'pdf';
      case 'STEP':
        return 'unknown';
      case 'Video':
        return 'mp4';
      case 'ZIP':
        return 'zip';
      case 'ipt':
        return 'unknown';
      case 'sat':
        return 'unknown';
      case 'stp':
        return 'unknown';
      default:
        return 'unknown';
    }
  }
}
